import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/defineProperty";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { Message } from "element-ui";
import { getUserInfo, updataUserInfo } from "@/api/loginConfig/addUserList";
import crypto from "crypto";
export default {
  name: "adduserPage",
  props: {
    showing: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    var _ref;

    var validate = function validate(rule, value, callback) {
      if (value) {
        if (/[\u4E00-\u9FA5]/g.test(value)) {
          callback(new Error("不能输入汉字"));
        } else {
          // 验证通过
          callback();
        }

        callback();
      }
    };

    var speace = function speace(rule, value, callback) {
      if (value) {
        if (/[\u4E00-\u9FA5]/g.test(value)) {
          callback(new Error("不能输入空格"));
        } else {
          // 验证通过
          callback();
        }

        callback();
      }
    };

    return _ref = {
      dialogFormVisible: false,
      titleName: "",
      id: "",
      // names:'邮箱号',
      form: {
        user_name: "",
        passwd: "",
        phone: "",
        email: "",
        oauth: "",
        device_id: ""
      },
      user_name: "",
      phone: "",
      email: "",
      rules: {
        value: [//  { required: true, message: '请输入密码', trigger: 'blur' },
        //  { min: 6, max: 18, message: '长度在 6 到 18 个字符，不能有中文', trigger: 'blur'},
        {
          validator: validate,
          message: "不能有中文",
          trigger: "blur"
        }, {
          validator: speace,
          message: "不能有中文",
          trigger: "blur"
        }] // accass:[
        //   { required: true, message: '请输入账号', trigger: 'blur' },
        // ],
        // phoneNum:[
        //   { required: true, message: '请输入手机号', trigger: 'blur' },
        // ],
        //  email:[
        //   { required: true, message: '请输入邮箱', trigger: 'blur' },
        // ],

      },
      is_visitor: "2",
      searchgames: [],
      searchplatforms: [],
      searchchannels: [],
      searchpkgs: [],
      gameId: "",
      value1: "",
      value2: [],
      searchMark: {},
      searchData: {}
    }, _defineProperty(_ref, "id", ""), _defineProperty(_ref, "formLabelWidth", "120px"), _ref;
  },
  created: function created() {
    this.searchMark = {};
  },
  watch: {},
  computed: {
    isShow: {
      get: function get() {
        if (this.showing) {
          return this.showing;
        }
      },
      set: function set(val) {
        this.$emit("changeShow", false);
      }
    }
  },
  methods: {
    init: function init(id, item, num) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var tid, _yield$getUserInfo, data;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.dialogFormVisible = true;
                _this.is_visitor = item.visitor;

                if (!(num == 4)) {
                  _context.next = 14;
                  break;
                }

                _this.titleName = "用户详情";
                _this.form = {};
                tid = {
                  user_id: id,
                  game: item.game,
                  platform: item.platform,
                  channel: item.channel
                };
                _context.next = 8;
                return getUserInfo(tid);

              case 8:
                _yield$getUserInfo = _context.sent;
                data = _yield$getUserInfo.data;
                _this.form = _objectSpread({}, data);
                _this.user_name = data.user_name; // this.form.user_name= data.user_name
                // this.form.passwd=data.passwd

                _this.phone = data.phone;
                _this.email = data.email; // this.form.oauth=data.oauth

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    valChange: function valChange(val) {
      this.form.user_name = val;
    },
    passChange: function passChange(val) {
      this.form.passwd = val;
    },
    phoneChange: function phoneChange(val) {
      this.form.phone = val;
    },
    emailChange: function emailChange(val) {
      this.form.email = val;
    },
    resetForm: function resetForm(formName) {
      this.dialogFormVisible = false;
      this.$emit("refreshDataList");
      this.$emit("changeShow", false);
    },
    getmd5: function getmd5(str) {
      var a;
      var md5 = crypto.createHash("md5"); //update("中文", "utf8")

      md5.update(str);
      var a = md5.digest("hex"); //47bce5c74f589f4867dbd57e9ca9f808

      return a;
    },
    dataFormSubmit: function dataFormSubmit(formName) {
      var _this2 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          if (_this2.titleName == "用户详情") {
            _this2.searchMark.game = _this2.form.game;
            _this2.searchMark.platform = _this2.form.platform;
            _this2.searchMark.channel = _this2.form.channel;
            _this2.searchMark.pkg = _this2.form.pkg;
            _this2.searchMark.user_id = _this2.form.user_id;
            _this2.searchMark.ad_channel = _this2.form.ad_channel;
            _this2.searchMark.ad_placement = _this2.form.ad_placement;
            _this2.searchMark.user_name = _this2.form.user_name;

            if (_this2.form.passwd != null) {
              _this2.searchMark.passwd = _this2.getmd5(_this2.form.passwd);
            } else {
              _this2.searchMark.passwd = "";
            }

            _this2.searchMark.phone = _this2.form.phone;
            _this2.searchMark.email = _this2.form.email;
            _this2.searchMark.oauth = _this2.form.oauth;
            _this2.searchMark.kind = 1;
            updataUserInfo(_this2.searchMark).then(function (res) {
              if (res.status == 200) {
                Message.success(res.message); // this.$emit("refreshDataList");

                _this2.resetForm("ruleForm");
              } else {
                Message.warning(res.message); // this.$emit("refreshDataList");

                _this2.resetForm("ruleForm");
              }
            });
          }
        } else {
          return false;
        }
      });
    }
  },
  clearData: function clearData() {
    this.form = {};
    this.searchplatforms = [];
    this.searchchannels = [];
    this.searchpkg = [];
  }
};